import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { DropdownModule } from 'primeng/dropdown';
import { TableLazyLoadEvent, TableModule } from 'primeng/table';
import { AllMentorsScheduledCallResponse } from '../../../models/super-admin/allMentorsScheduledCallResponse';
import { AllMentorsScheduledCallRequest } from '../../../models/super-admin/allMentorsScheduledCallResquest';
import { RouterModule } from '@angular/router';
import { SuperAdminService } from '../../../services/super-admin/super-admin.service';
import { SearchByNameResponse } from '../../../models/account/searchByNameResponse';
import { AutoCompleteCompleteEvent, AutoCompleteModule } from 'primeng/autocomplete';
import { UtilityService } from '../../../services/utility/utility.service';

@Component({
  selector: 'app-scheduled-mentor-calls',
  standalone: true,
  imports: [CalendarModule,CommonModule,DropdownModule,AutoCompleteModule,ReactiveFormsModule,TableModule,ButtonModule,RouterModule],
  templateUrl: './scheduled-mentor-calls.component.html',
  styleUrl: './scheduled-mentor-calls.component.scss'
})
export class ScheduledMentorCallsComponent implements OnInit{
  filterForm!: FormGroup;
  isSearching: boolean = false;
  submitted:boolean = false;
  meetings: AllMentorsScheduledCallResponse[] = [];
  total: number = 0;
  first: number = 0;
  rowSize: number = 10;
  pageSize: number  =10;
  request!: AllMentorsScheduledCallRequest;
  mentorNames:SearchByNameResponse[] = []
  studentNames:SearchByNameResponse[] = []

  constructor(
    private fb: FormBuilder,
    private superAdminService:SuperAdminService,
    private utilityService: UtilityService
  ){}
  ngOnInit(): void {
    this.filterForm = this.fb.group({
      mentorName:[null],
      studentName:[null],
      fromDate: [null],
      toDate: [null]
      // status: [MeetingState.Active]
    });
    this.search(1);
  }

  search(pageNumber: Number){
    this.isSearching = true;
    this.request = {
      mentorName: this.filterForm.value.mentorName,
      studentName: this.filterForm.value.studentName,
      startDate: this.filterForm.value.fromDate,
      endDate: this.filterForm.value.toDate,
      pageNumber: pageNumber,
      pageSize: this.rowSize
    }
    this.superAdminService.listAllMentorsScheduledCalls(this.request).subscribe({
      next:(response) => {
        this.meetings = response.result;
        this.total = response.total;
        this.isSearching = false;
      },
      error: (error) => {
        console.error(error);
        this.isSearching = false;
      }
    })
  }
  filterMentorNames(event: AutoCompleteCompleteEvent) {
        if (event.query.length > 2) {
          this.utilityService.searchNamesByRole({
            roleName: 'Mentor',
            searchText: event.query
          }).subscribe({
            next: (response) => {
              this.mentorNames = response.result
            }
          });
        } else {
          this.mentorNames = [];
        }
      }
  
    filterStudentNames(event: AutoCompleteCompleteEvent) {
      if (event.query.length > 2) {
        this.utilityService.searchNamesByRole({
          roleName: 'Student',
          searchText: event.query
        }).subscribe({
          next: (response) => {
            this.studentNames = response.result
          }
        });
      } else {
        this.studentNames = [];
      }
    }

  getLocalDate(dateArg: string) {
    var date = new Date(dateArg);
    // Format the local date as "March 06, 2025"
    const localDate = date.toLocaleDateString(undefined, {
      year: 'numeric',
      month: 'long',
      day: '2-digit'
    }).replace(/(\d{2}) (\w+) (\d{4})/, '$2 $1, $3'); // Ensure "March 06, 2025"

    return localDate;
  }
  getLocalTime(dateArg: string) {
    var date = new Date(dateArg);
    // Format the local time as "9:30 AM"
    const localTime = date.toLocaleTimeString(undefined, {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    }).toUpperCase(); // Capitalize AM/PM

    return localTime;
  }

  openCalendlyURI(arg0: any) {
    window.open(arg0, '_blank');
  }

  onLazyLoad($event: TableLazyLoadEvent) {
    const pageNumber = Math.floor(($event.first ?? 0) / ($event.rows ?? this.rowSize)) + 1;
    this.first = $event.first ?? 0;
    this.rowSize = $event.rows ?? this.rowSize;
    this.request = { ...this.request, pageNumber: pageNumber, pageSize: this.rowSize };
    this.search(pageNumber);
  }

}
